import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { getHostedVideoFoldersAsync } from '../actions';
import { sortList } from '../helpers';
import { HostedVideoActions } from '../types';

import { initialHostedVideoState } from './index';

const getHostedVideoFoldersReducer: Reducer<typeof initialHostedVideoState, HostedVideoActions> = (
  state = initialHostedVideoState,
  action
) => {
  switch (action.type) {
    case getType(getHostedVideoFoldersAsync.request): {
      return {
        ...state,
        isPending: true,
        isError: false,
        error: null
      };
    }
    case getType(getHostedVideoFoldersAsync.success): {
      const list = action.payload;
      const sortedList = sortList('date', list);
      return {
        ...state,
        list: sortedList,
        isPending: false,
        isError: false
      };
    }
    case getType(getHostedVideoFoldersAsync.failure): {
      const error = action.payload;
      return {
        ...state,
        error,
        isPending: false,
        isError: true
      };
    }
    default:
      return state;
  }
};

export default getHostedVideoFoldersReducer;
